import { DriverWorkShiftEdit } from "@/models/driverWorkShiftsAndCycle";
import { DriverWorkShift } from "@/models/operationPlans";
import { countStrByte } from "@/util";
import { BINS, shiftToTime } from "../OperationPlans/OperationPlansConstansts";

export const DriverWorkCyclesConstants = {
  DriverWorkCycleAndShifts: "勤務シフト・勤務サイクル",
  OfficeName: "会社／営業所",
  DriverWorkCycleAndShiftsDetail: "勤務シフト・勤務サイクル詳細",
  DriverWorkCycle: "勤務サイクル",
  DriverWorkShifts: "勤務シフト",
  DriverWorkShiftName: "勤務シフト名",
  DriverWorkCycleName: "勤務サイクル名",
  DriverWorkCycleNumber: "サイクル番号",
  DriverWorkCycleAdd: "サイクル追加",
  DriverWorkCycleRemov: "サイクル削除",
  Shift: "シフト",
  DayOff: "休み",
  WeekDay: "平日稼働時間",
  Holiday: "休日稼働時間",
  StartTime: "開始時刻",
  EndTime: "終了時刻",
  Description: "説明",
  DriverWorkShiftEdit: "勤務シフト編集",
  DriverWorkShiftCreate: "勤務シフト追加",
  DriverWorkCycleEdit: "勤務サイクル編集",
  DriverWorkCycleCreate: "勤務サイクル追加",
  SameWorkingTime: "平日と稼働時間同じ",
  LengthError:
    "記号以外の6バイト(全角3文字, 半角6文字)以内の文字を設定してください。",
  DescriptionError: "全角218文字以内で設定してください。",
  SameTimeError:
    "開始時刻と同じ時間が設定されています。時間を見直してください。",
  ConfirmTitle: "更新確認",
  UpdateWarning: `この変更は、翌々月1日以降の車両稼働予定から適用されます。
それより前に適用したい場合、車両と紐付ける勤務サイクルの適用開始日を再設定してください。 `,
} as const;

export const PAGE_SIZE = 30;

export const getTimeLabel = (isHoliday: boolean, shift: DriverWorkShift) => {
  if (
    (isHoliday && shift.holidayIsDayOff) ||
    (!isHoliday && shift.weekdayIsDayOff)
  ) {
    return "ー";
  }

  const times = shiftToTime(isHoliday, shift);
  if (Object.values(times).some((v) => v == null)) {
    return "ー";
  }

  const { fromH, fromM, toH, toM } = times;

  return `${fromH}:${fromM?.toString().padStart(2, "0") ?? ""} - ${toH}:${
    toM?.toString().padStart(2, "0") ?? ""
  }`;
};

export const getBin = (
  target: "from" | "to",
  hours?: string,
  minutes?: string
): number | undefined => {
  return BINS.find((bin) => bin[target] === `${hours}:${minutes}`)?.bin;
};

export const getTime = (
  target: "from" | "to",
  binNum?: number
): [string | undefined, string | undefined] => {
  const binObj = BINS.find(({ bin }) => bin === binNum);
  if (binObj == null) {
    return [undefined, undefined];
  }

  const times = binObj[target].split(":");
  if (times.length !== 2) {
    return [undefined, undefined];
  }

  return [times[0], times[1]];
};

const contains_2byte_symbol =
  /[！”＃＄％＆’（）＝～｜‘｛＋＊｝＜＞？＿－＾￥＠「；：」、。・]+/;
const contains_symbol = /[!-/:-@[-`{-~]+/;
export const validName = (name: string): boolean => {
  return (
    countStrByte(name) <= 6 &&
    !contains_2byte_symbol.test(name) &&
    !contains_symbol.test(name)
  );
};

export const validDescription = (description: string): boolean => {
  return countStrByte(description) <= 436;
};

export const duplicateTime = (
  key: "weekday" | "holiday",
  shift: DriverWorkShiftEdit
) => {
  const startHours = shift[`${key}StartHours`];
  const startMinutes = shift[`${key}StartMinutes`];
  const endHours = shift[`${key}EndHours`];
  const endMinutes = shift[`${key}EndMinutes`];

  return (
    startHours != null &&
    startMinutes != null &&
    endHours != null &&
    endMinutes != null &&
    startHours === endHours &&
    startMinutes === endMinutes
  );
};

export const CYCLE_MAX_ROW = 100;
export const CYCLE_MIN_ROW = 1;
